import { Box } from '@mui/material'

import { useAppContext } from '@/hooks'
import { ReleaseStatusEnum } from '@/rtkApi/mddApiSliceGeneratedV2'

import { STATUS_PILL } from './types'

export const StatusPill = ({ status }: { status: ReleaseStatusEnum }) => {
	const { t } = useAppContext()
	const meta = STATUS_PILL[status]

	return (
		<Box
			sx={{
				alignItems: 'center',
				bgcolor: meta.background,
				borderRadius: '999px',
				color: meta.color,
				display: 'inline-flex',
				fontSize: '10px',
				fontWeight: 700,
				letterSpacing: '.04em',
				px: '8px',
				py: '2px',
				textTransform: 'uppercase',
			}}
		>
			{t(meta.labelKey)}
		</Box>
	)
}
